var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-actions',{attrs:{"has-greater-then-two-actions":_vm.hasGreaterThenTwoActions,"secondary-actions-in-single-button":_vm.secondaryActionsInSingleButton,"actions":_vm.actions,"data-cy":_vm.dataCy},on:{"clicked":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }